import Scheduled from "@/stores/modules/maintenance/ScheduledMaintenanceModule";
import UserApi from "@/api/userApi";

export default {
  state: {
    selected: {},
    maintenanceState: "",
    users: []
  },
  modules: {
    Scheduled
  },
  getters: {
    getSelected: state => {
      return state.selected;
    },
    getMaintenanceState: state => {
      return state.maintenanceState;
    },
    getUsers: state => state.users
  },
  actions: {
    setSelected({ commit }, value) {
      commit("SELECTED", value);
    },

    setUsers: async ({ state, commit, rootGetters }) => {
      state.assignedToUser = rootGetters["User/getUser"].Id;
      const api = new UserApi(rootGetters["User/getUser"].OrganizationCode);

      // Get all users
      let users = [];
      const res = await api.getUsersList({ skip: 0, limit: 1 });
      users = res.result;
      if (res.total > res.result.length) {
        const res2 = await api.getUsersList({ skip: 1, limit: res.total });
        users = users.concat(res2.result);
      }

      commit("UPDATE_USERS", users);
    },

    setMaintenanceState({ commit }, args) {
      commit("MAINTENANCE_STATE", args);
    },

    reset: ({ commit }) => {
      commit("RESET");
    }
  },
  mutations: {
    SELECTED: (state, payload) => {
      state.selected = payload;
    },
    MAINTENANCE_STATE: (state, payload) => {
      state.maintenanceState = payload;
    },
    UPDATE_USERS: (state, payload) => {
      state.users = payload;
    },
    RESET: state => {
      state.selected = {};
      state.maintenanceState = "";
      state.users = [];
    }
  },
  namespaced: true
};
